<template>
    <el-container>
        
        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row >
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="用户名" prop="userName" >
                            <el-input v-model="searchData.userName" placeholder="用户名" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="订单号" prop="orderNo">
                            <el-input v-model="searchData.orderNo" placeholder="订单号" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="机构" prop="org">
                            <el-select v-model="searchData.org" clearable placeholder="机构"  size="small" style="width: 100%">
                                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="支付状态" prop="paymentStatus">
                            <el-select v-model="searchData.paymentStatus" clearable  placeholder="支付状态" size="small" style="width: 100%">
                                <el-option label="已支付" :value="1"></el-option>
                                <el-option label="未支付" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="是否需要开发票" prop="isBill" >
                            <el-select v-model="searchData.isBill" clearable  placeholder="是否需要开发票" size="small" style="width: 100%">
                                <el-option label="是" :value="1"></el-option>
                                <el-option label="否" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="是否已开发票" prop="isdrawBill" >
                            <el-select v-model="searchData.isdrawBill" clearable  placeholder="是否已开发票" size="small" style="width: 100%">
                                <el-option label="是" :value="1"></el-option>
                                <el-option label="否" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="创建日期" prop="phone" >
                            <el-date-picker
                                size="small"
                                style="width: 80%"
                                v-model="createTime"
                                type="daterange"
                                range-separator="至"
                                @change="changeTime"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item >
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="onSubmit()">查询</el-button>
                    <el-button type="primary" size="small" icon="el-icon-upload" @click="exportExcel()" :disabled="isExport">导出缴费确认表</el-button>
                </el-form-item>
            
            </el-form>
            <el-table
                :data="staffData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
            >
                <el-table-column
                    prop="orderNo"
                    label="订单号"
                    width="200"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="orgName"
                    label="所属机构"
                    width="300"
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="用户名"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="paymentStatus"
                    label="支付状态"
                    width="100"
                    :formatter="f_orderStatus"
                >
                </el-table-column>
                <el-table-column
                    prop="paymentTime"
                    label="支付时间"
                    width="200"
                    :formatter="dateFormat"
                >
                </el-table-column>
                <el-table-column
                    prop="amount"
                    label="总金额"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="isBill"
                    label="是否需要发票"
                    width="130"
                    :formatter="f_isBill"
                >
                </el-table-column>
                <el-table-column
                    prop="receiver"
                    label="收货人"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="telNum"
                    label="联系手机"
                    width="130"
                >
                </el-table-column>
                <el-table-column
                    prop="isdrawBill"
                    label="是否已开发票"
                    width="130"
                    :formatter="f_isdrawBill"
                >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                    width="200"
                    :formatter="dateFormat"
                >
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                >
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="confirmBill(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.paymentStatus == 1 && scope.row.isBill == 1 && scope.row.isdrawBill == 0">确认开票</el-button>
                        <el-button @click="pay(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.paymentStatus == 0 && scope.row.payType == 3">汇款购买</el-button>
                        <!--<el-button @click="pay(scope.$index, scope.row)" type="text" v-if="scope.row.paymentStatus == 3" size="small" >汇款购买</el-button>-->
                        <el-button @click="pos(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.payType == 4 ">易宝POS机支付</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
  import https from '@/https.js'
  import validate from '@/api/validate.js'
  import {dateFormat} from '@/api/utils.js'
  import Base64 from '@/api/video/lib/base64.js'
  import qs from 'qs'

  export default {
    name: "order",
    data() {
      return {
        loading: true,
        searchData: {
          createTimeStart: "",
          createTimeEnd: "",
          orderNo: "",
          userName: "",
          isdrawBill: "",
          isBill: "",
          org: "",
          size: 0,
          paymentStatus: '',
          page: 1,
        },
        org: [],
        createTime: [],
        rules: {
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 6, max: 20, message: '长度为6-20 个字符', trigger: 'blur' }
          ],
          phone: [
            {required: true, message: '请输入电话', trigger: 'blur' },
            { validator: validate.validatePhone, trigger: 'blur' }
          ],
          realName: [
            { max:50, message: '长度不得超过50个字符', trigger: 'blur' }
          ],
          email: [
            { validator: validate.validateEmail, trigger: 'blur' }
          ],
          qq: [
            { validator: validate.validateQQ, trigger: 'blur' }
          ],
          education: [
            { max:50, message: '长度不得超过50个数字', trigger: 'blur' }
          ],
          province: [
            { max:50, message: '长度不得超过50个数字', trigger: 'blur' }
          ],
        },
        total: 0,
        pageSize:10,
        currentPage: 1,
        addStaff: false,
        staffData: [],
        isUpdate: false,
        isExport: true
      }
    },
    watch: {
      'searchData.paymentStatus'(val) {
        if(val == 1) {
          this.isExport = false;
        } else {
          this.isExport = true;
        }
      }
    },
    methods: {
      f_isdrawBill(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '否';
        }
        if(cellValue == 1) {
          return '是';
        }
      },
      f_isBill(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '否';
        }
        if(cellValue == 1) {
          return '是';
        }
      },
      f_orderStatus(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '未支付';
        }
        if(cellValue == 1) {
          return '已支付';
        }
        if(cellValue == 2) {
          return '支付中';
        }
        if(cellValue == 3) {
          return '支付失败';
        }
      },
      dateFormat(row, column, cellValue, index) {
        if(cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue
        }
      },
      changeTime(val) {
        if(val && val.length == 2) {
          this.searchData.createTimeStart = val[0];
          this.searchData.createTimeEnd = val[1];
        } else {
          this.searchData.createTimeStart = "";
          this.searchData.createTimeEnd = "";
        }
      },
      exportExcel() {
        // excelCreateTimeStart
        // excelCreateTimeEnd

        let params = this.searchData;
        params['excelCreateTimeStart'] = this.searchData.createTimeStart;
        params['excelCreateTimeEnd'] = this.searchData.createTimeEnd;

        https.fetchGet('/mallOrderInfo/excelByMallOrderInfo?'+qs.stringify(params),"" , "blob").then((data) => {
          let file = data.data;
          let filePath = URL.createObjectURL(file);
          var link = document.createElement('a')
          link.href = filePath;
          link.download = decodeURI(data.headers.filename);
          link.click();
          URL.revokeObjectURL(link.href)
        }).catch(err => {
              console.log(err);
              this.$message.error('网络异常！');
            }
        )

        //window.location.href = https.baseURL+"/mallOrderInfo/excelByMallOrderInfo?"+qs.stringify(params);
      },
      pay(index,row) {
        this.$confirm('该操作将修改此订单状态为已支付，确认支付?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            orderId: row.orderId,
            userName: row.userName,
            paymentStatus: 1
          };
          https.fetchPost('/mallOrderInfo/updateMallOrderInfoVoByOrderId', params, "json").then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '重置成功!'
              });
              this.onSubmit();
            } else {
              this.$message({
                type: 'info',
                message: '重置失败' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          )

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      confirmBill(index,row) {
        this.$confirm('确认开票?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            orderId: row.orderId,
            isdrawBill: 1
          };
          https.fetchPost('/mallOrderInfo/updateMallOrderInfoVoByOrderId', params, "json").then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.onSubmit();
            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          )

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      pos(index, row) {
        this.$router.push({
          name: "posPay",
          query: {orderId: row.orderId},
        })
      },
      detail(row) {
        this.$router.push({
          name: "orderDetail",
          query: {orderId: row.orderId},
        })
      },
      onSubmit(val) {
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = this.pageSize;
        let params = this.searchData;
        this.loading = true;
        https.fetchPost('/mallOrderInfo/selectMallOrderInfoVoByMallOrderInfo',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.staffData = data.data.data.list;
            this.total = data.data.data.total;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              type: 'info',
              message: msg
            })
          }
        }).catch(err=>{
              console.log(err)
              this.loading = false;
            }
        )
      },
      handleSizeChange() {},

      handleCurrentChange(val) {
        this.onSubmit(val);
      },
      selectOrg() {
        https.fetchGet('/managerOrganization/getOrganizationList','', 'from' ).then((data) => {
          let code = data.data.code;
          if(code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
            }
        );
      },
    },
    created: function () {
      this.searchData.org = this.$store.state.orgCode;
      this.onSubmit();
      this.selectOrg();
    }
  };
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    .cls-col {
        margin-right: 20px;
    }
</style>
